import React from "react";
import { BsFlagFill } from "react-icons/bs";
import { FaSmile, FaTimes } from "react-icons/fa";

const ContactSMS = ({message, setMessage}) => {
  return (
    <>
      <div className="preview-block">
        <div className="sms-form light">
          <label>From</label>
          <input type="text" placeholder="" />

          <label className="mt-3">To</label>
          <div className="to-field">
            <span className="avatar">A</span>
            <span className="name">Abuzer</span>
            <button className="remove-btn">
              <FaTimes />
            </button>
          </div>

          <label className="mt-3">Phone Number</label>
          <select className="highlight-select">
            <option>New Phone Number</option>
          </select>

          <input type="text" placeholder="e.g. +6010244669" className="mt-2" />

          <label className="mt-3">Message</label>
          <div className="message-wrapper">
            <textarea
              className="message-box"
              placeholder="Type your SMS here..."
              maxLength={160}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />

            <div className="message-tools">
              <button className="icon-btn">
                <FaSmile />
              </button>
              <button className="icon-btn flag">
                <BsFlagFill />
              </button>
            </div>
          </div>

          <div className="message-footer">
            <span>0 / 160 Characters 0 SMS</span>
          </div>

          <label className="mt-3">Tags</label>
          <button className="tag-add">+</button>

          <div className="preview-switcher justify-content-end">
            <button className="px-4" style={{ flex: 0 }}>
              Cancel
            </button>
            <button className="px-4 active" style={{ flex: 0 }}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactSMS;
